<template>
  <div class="group-hover:scale-110 transition-transform cursor-pointer">
    <span
      class="inline-flex items-center gap-x-1.5 rounded-full px-2 py-1 text-xs font-medium"
      :class="conditionStyles[row.conditions]?.class"
    >
      <component
        :is="conditionStyles[row.conditions]?.icon"
        class="size-4"
        aria-hidden="true"
      />
      {{ conditionStyles[row.conditions]?.label || row.conditions }}
    </span>
  </div>
</template>

<script setup>
import {
  UserIcon,
  ClockIcon,
  CalendarIcon,
  FolderPlusIcon,
  StarIcon
} from '@heroicons/vue/24/solid';

defineProps({
  row: {
    type: Object,
    default: () => ({})
  }
});

const conditionStyles = {
  noSubscription: {
    class: 'bg-red-100 text-red-800',
    icon: UserIcon,
    label: 'No Subscription'
  },
  hourSubscription: {
    class: 'bg-blue-100 text-blue-800',
    icon: ClockIcon,
    label: '1 Hour Subscription'
  },
  monthlySubscription: {
    class: 'bg-green-100 text-green-800',
    icon: CalendarIcon,
    label: 'Monthly Subscription'
  },
  newProgramInCategory: {
    class: 'bg-yellow-100 text-yellow-800',
    icon: FolderPlusIcon,
    label: 'New Program in Category'
  },
  newFeature: {
    class: 'bg-purple-100 text-purple-800',
    icon: StarIcon,
    label: 'New Feature'
  },
  personalizedBannerForTheCategory: {
    class: 'bg-purple-100 text-purple-800',
    icon: StarIcon,
    label: 'Personalized Banner for the Category'
  }
};
</script>
